import { Image as ChakraImage, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';
import { Investment } from '../../types';
type DashboardTableProps = {
  data: Investment[];
};

export const DashboardTable: React.FC<DashboardTableProps> = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Flex flexDirection="column" mt="40px" flex={1} borderWidth="1px" borderColor="gray.50" borderRadius="10px">
      <Table border="transparent" colorScheme="lightgray" variant="striped" w="100%">
        <Thead>
          <Tr>
            <Th w={'19%'} borderWidth="0px">
              Investment
            </Th>
            <Th w={'19%'} borderWidth="0px">
              Photo
            </Th>
            <Th w={'25%'} borderWidth="0px">
              Location
            </Th>
            <Th w={'19%'} borderWidth="0px">
              Total Income
            </Th>
            <Th w={'19%'} borderWidth="0px">
              CurrentValue
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row, i) => {
            return (
              <Tr
                key={`investment-${i}`}
                cursor={'pointer'}
                onClick={() => {
                  const isSFR = Boolean(row.id);
                  if (isSFR) {
                    navigate(`${ROUTES.properties}/${row.id}`);
                  } else {
                    window.open(`https://www.concreit.com/strategies/cash-flow`, '_blank');
                  }
                }}>
                <Td borderWidth="0px" fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                  {row.name}
                </Td>
                <Td borderWidth="0px">{<ChakraImage borderRadius="5px" w={'60px'} h={'40px'} src={row.photo} />}</Td>
                <Td borderWidth="0px">{row.location}</Td>
                <Td
                  borderWidth="0px"
                  pl={7}
                  fontFamily={FontFamily.HELVETICA_NOW_BOLD}
                  borderColor="black"
                  color={'green.400'}>
                  {currency.format(row.income, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                </Td>
                <Td borderWidth="0px" pl={7} fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                  {currency.format(row.currentValue, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Flex>
  );
};
